import React, { FC } from 'react'
import { BreadcrumbItem, Breadcrumbs } from './Breadcrumbs'
import { Container, Box, Heading, Text, Link, Image } from '@gassan-ui'
import { useLocalization } from './Localization'
import { getKontentImage } from '@lib/kontent'

type Props = {
  breadcrumbItems: BreadcrumbItem[]
  title: string
  alt: string
  text: string
  onClickMakeAppointment: () => void
  image?: string
}

const OverviewHeader: FC<Props> = ({
  breadcrumbItems,
  title,
  alt,
  text,
  onClickMakeAppointment,
  image
}) => {
  const { messages } = useLocalization()
  return (
    <Container
      position="relative"
      display="flex"
      alignItems="center"
      pt={{
        _: '2rem',
        medium: '2rem',
        large: '4rem'
      }}
      pb={{
        _: '2rem',
        medium: '2.5rem',
        large: '3rem'
      }}
    >
      <Box maxWidth="34rem">
        <Breadcrumbs items={breadcrumbItems} mb="3rem" />
        <Heading
          mb={{
            _: '1rem',
            large: '1.5rem'
          }}
          variant="h1"
          as="h1"
        >
          {title}
        </Heading>
        <Text
          mb={{
            _: '1.5rem',
            medium: '2rem',
            large: '2.5rem'
          }}
        >
          {text}
        </Text>
        <Link as="button" variant="brown" onClick={onClickMakeAppointment}>
          {messages.global.makeAppointment}
        </Link>
      </Box>
      <Box
        display={{
          _: 'none',
          large: 'block'
        }}
        position="absolute"
        right="0"
        height="100%"
        width="50%"
        maxWidth="calc(100% - 34rem)"
        top="0"
      >
        {image && (
          <Image
            sources={[getKontentImage(image, { width: 900 })]}
            placeholderSrc={getKontentImage(image, { width: 20 })}
            height="100%"
            width="100%"
            alt={alt}
          />
        )}
      </Box>
    </Container>
  )
}

export default OverviewHeader
